<!-- eslint-disable vue/no-mutating-props -->
<script setup lang="ts">
import type { SiteBlock } from '../../../types/site'

defineProps<{ block: SiteBlock }>()

const t = useSiteEditorT()

const LEVELS = [
  { value: 1, label: t('site.f.heading.opt_h1', 'H1') },
  { value: 2, label: t('site.f.heading.opt_h2', 'H2') },
  { value: 3, label: t('site.f.heading.opt_h3', 'H3') }
] as const
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <UFormField :label="t('site.f.heading.text', 'Text')">
    <UInput
      v-model="block.data.text"
      class="w-full"
    />
  </UFormField>
  <UFormField :label="t('site.f.heading.level', 'Level')">
    <SiteEditorOptionToggle
      :options="LEVELS"
      :model-value="block.data.level ?? 1"
      @update:model-value="block.data.level = Number($event)"
    />
  </UFormField>
</template>
